import { useState } from 'react';
import { Col, Row, Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { SectionTitle } from './SectionTitle';
import { MemberDependentInfo } from './MemberDependentInfo';
import EnrollmentCoverageTypes from './EnrollmentCoverageTypes';
import {
  ProductDentalIcon,
  ProductIcon,
  ProductVisionIcon,
} from 'src/Admin/components/Enrollment/components/EnrollmentIconsSvg';

export const MainDetailsCard = () => {
  const { themeValuesObject } = useSelector(({ theme }) => theme) || {};
  const [activeToggleId, setActiveToggleId] = useState('member-info');
  return (
    <div className="main-details-section">
      <Row className="m-0">
        <Col md={8} className="left-block">
          {/*section title */}
          <SectionTitle title="Employee Profile" />
          <Row>
            <Col>
              <Accordion defaultActiveKey="member-info">
                <div>
                  <MemberDependentInfo
                    activeToggleId={activeToggleId}
                    setActiveToggleId={setActiveToggleId}
                    themeValuesObject={themeValuesObject}
                    eventKey={'member-info'}
                  />
                  <div className="dependent-info-section thicker-border-bottom">
                    <SectionTitle title="Dependents Information" />
                    <MemberDependentInfo
                      activeToggleId={activeToggleId}
                      setActiveToggleId={setActiveToggleId}
                      themeValuesObject={themeValuesObject}
                      eventKey={'dependent-info-1'}
                    />
                    <MemberDependentInfo
                      activeToggleId={activeToggleId}
                      setActiveToggleId={setActiveToggleId}
                      themeValuesObject={themeValuesObject}
                      eventKey={'dependent-info-2'}
                    />
                    <MemberDependentInfo
                      activeToggleId={activeToggleId}
                      setActiveToggleId={setActiveToggleId}
                      themeValuesObject={themeValuesObject}
                      eventKey={'dependent-info-3'}
                    />
                    <MemberDependentInfo
                      activeToggleId={activeToggleId}
                      setActiveToggleId={setActiveToggleId}
                      themeValuesObject={themeValuesObject}
                      eventKey={'dependent-info-4'}
                    />
                  </div>
                  <div className="coverage-info-section mt-5 thicker-border-bottom">
                    <SectionTitle
                      title={'Coverage(s)'}
                      subTitle={'You’ve selected 1 Medical Coverage.'}
                    />
                    <div className="mt-4">
                      <EnrollmentCoverageTypes
                        name="Medical"
                        iconType={
                          <ProductIcon
                            classNameSecondary="medical-product-icon-secondary"
                            classNamePrimary="medical-product-icon"
                          />
                        }
                        premiumValue={'$108.78'}
                        dependentCount={4}
                      />
                      <EnrollmentCoverageTypes
                        name="Dental"
                        iconType={
                          <ProductDentalIcon
                            classNameSecondary="dental-product-icon-secondary"
                            classNamePrimary="dental-product-icon"
                          />
                        }
                        premiumValue={'$107.00'}
                        dependentCount={4}
                      />
                      <EnrollmentCoverageTypes
                        name="Vision"
                        iconType={
                          <ProductVisionIcon
                            classNameSecondary="vision-product-icon-secondary"
                            classNamePrimary="vision-product-icon"
                          />
                        }
                        premiumValue={'0.00'}
                      />
                    </div>
                  </div>
                </div>
              </Accordion>
            </Col>
          </Row>
        </Col>
        <Col md={4} className="right-block p-0"></Col>
      </Row>
    </div>
  );
};
